var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "650" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v("Treasure Bundle (" + _vm._s(this.rules.name) + ")"),
            ]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "mb-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          disabled: "",
                          label: "UID:",
                          "hide-details": "",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.model.uid,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "uid",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.uid",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("r-smart-offer-bundle-treasure-type", {
                        attrs: { model: _vm.model.type, label: "Type" },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "type", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Name" },
                        model: {
                          value: _vm.model.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-expansion-panels",
                [
                  _c("r-guard-panel", {
                    attrs: { model: _vm.model.guard, title: "Guard Config" },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "guard", $event)
                      },
                    },
                  }),
                  _c("r-guard-money-panel", {
                    attrs: {
                      model: _vm.model.guardMoney,
                      title: "Guard Money",
                    },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "guardMoney", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { dense: "" } },
                [
                  _vm.product_groups.length > 0
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "5", sm: "5" } },
                        [
                          _c("r-product-dropdown", {
                            attrs: {
                              model: _vm.model.playProduct,
                              groups: _vm.product_groups,
                              label: "Play Product",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(
                                  _vm.model,
                                  "playProduct",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Bonus Unlimited", "hide-details": "" },
                        model: {
                          value: _vm.model.bonusUnlimited,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "bonusUnlimited", $$v)
                          },
                          expression: "model.bonusUnlimited",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "5", sm: "5" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.are_you_sure,
                          "item-text": "name",
                          "item-value": "id",
                          label: "Are you sure (type)",
                        },
                        model: {
                          value: _vm.model.areYouSureType,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "areYouSureType", $$v)
                          },
                          expression: "model.areYouSureType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "pt-6", attrs: { dense: "" } },
                [
                  _c(
                    "v-expansion-panels",
                    [
                      _c("r-treasure-level-config-panel", {
                        attrs: {
                          items: _vm.model.basicLevels,
                          title: "Basic Levels",
                        },
                        on: {
                          "update:items": function ($event) {
                            return _vm.$set(_vm.model, "basicLevels", $event)
                          },
                        },
                      }),
                      _c("r-treasure-level-config-panel", {
                        attrs: {
                          items: _vm.model.bonusLevels,
                          title: "Bonus Levels",
                        },
                        on: {
                          "update:items": function ($event) {
                            return _vm.$set(_vm.model, "bonusLevels", $event)
                          },
                        },
                      }),
                      _c("r-currency-panel", {
                        attrs: {
                          items: _vm.model.continuePrice,
                          title: "Continue Price",
                        },
                        on: {
                          "update:items": function ($event) {
                            return _vm.$set(_vm.model, "continuePrice", $event)
                          },
                        },
                      }),
                      _c("r-reward-panel", {
                        attrs: {
                          model: _vm.model.winReward,
                          title: "Win Reward",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "winReward", $event)
                          },
                        },
                      }),
                      _c("r-treasure-lower-cap-config-panel", {
                        attrs: {
                          model: _vm.model.lowerCapConfig,
                          title: "Lower Cap",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "lowerCapConfig", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }